<ng-container *ngIf="showedContact">
  <div class="viewContainer">
    <span class="typeIcon">
      <mat-icon appContactTypeIcon [type]="showedContact!.type"></mat-icon>
    </span>
    <span class="contactValue">
      {{ showedContact!.value | humanizePhone }}
    </span>
  </div>
  <div *ngIf="contactsCount > 1" class="contactsBadgeWrap" title="altri {{contactsCount - 1}} contatti">
    +{{contactsCount- 1}}
  </div>
</ng-container>
